import $http from '../http';

// 获取申报大厅岗位列表
export function postDeclarationHall (data,params) {
  return $http({
    url: `/xmt/post/declarationHall`,
    data,
    params,
    method: 'post'
  });
}

// 获取岗位详情
export function postDeclarationHallPostInfo (data) {
  return $http({
    url: '/xmt/post/declarationHall/postInfo',
    data,
    method: 'get'
  })
}

// 获取项目公示列表
export function planReleaseList (data) {
  return $http({
    url: '/xmt/planRelease/list',
    data,
    method: 'get'
  })
}

// 获取对应分类里面的项目
export function planReleaseGetPlanByCategory (data) {
  return $http({
    url: '/xmt/planRelease/getPlanByCategory',
    data
  })
}

// 申请人才岗位
export function declarationRegistrationAddRegistration (data) {
  return $http({
    // url: 'http://10.1.205.238:8888/xmt/declarationRegistration/addRegistration',
    url: '/xmt/declarationRegistration/addRegistration',
    data,
    method: 'post'
  })
}

// 修改申请
export function declarationRegistrationUpdateRegistration (data) {
  return $http({
    // url: 'http://10.1.204.9:8888/xmt/declarationRegistration/updateRegistration',
    url: '/xmt/declarationRegistration/updateRegistration',
    data,
    method: 'post'
  })
}

// 获取申请详情
export function getApplyDetailById (id) {
  return $http({
    // url: `http://10.1.205.238:8888/xmt/declarationRegistration/infoRegistration/${id}`
    url: `/xmt/declarationRegistration/infoRegistration/${id}`
  })
}

// 获取最后一次提交的申请
export function declarationRegistrationGetLastRegistration () {
  return $http({
    // url: 'http://10.1.205.238:8888/xmt/declarationRegistration/getLastRegistration',
    url: '/xmt/declarationRegistration/getLastRegistration'
  })
}

// 获取所有枚举
export function postGetAllEnum (data) {
  return $http({
    url: '/xmt/post/getAllEnum',
    data
  })
}

// 获取岗位宣传内容
export function planPubGet () {
  return $http({
    url: '/xmt/planPub/get'
  })
}

// 获取公告内容
export function tanlentConfigSelectConfig () {
  return $http({
    url: '/xmt/tanlentConfig/selectConfig'
  })
}

// 判断是否可以提交申报
export function declarationRegistrationHasSameApply (data) {
  return $http({
    url: '/xmt/declarationRegistration/hasSameApply',
    data
  })
}
